module.exports = __webpack_public_path__ + "lettuce.jpg?fea2a82662ff8e0f80b11443193cc4d9";